export default "<ng-container *ngIf=\"cpr$ | async as cpr\">\r\n  <span>{{ cpr?.cpr }}</span>\r\n</ng-container>\r\n"